import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const CompliancePage = lazy(() => import('./CompliancePage'));

const routes: RouteObject[] = [
  { path: '/compliance', element: <Guard any={['tax.read']}><CompliancePage /></Guard> },
];
export default routes;
